import { render, staticRenderFns } from "./GuestBookingPage.vue?vue&type=template&id=27971ec9&"
import script from "./GuestBookingPage.vue?vue&type=script&lang=ts&"
export * from "./GuestBookingPage.vue?vue&type=script&lang=ts&"
import style0 from "./GuestBookingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports